import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, Grid, TextField, Typography, MenuItem, Alert } from '@mui/material';

import { useHistory } from 'react-router-dom';
import { token } from '../../../../../api';
import api from '../../../../services/api';
import CustomFieldInput from '../shared/CustomFieldInput.js';
import { isFieldVisible } from '../shared/fieldVisibility';
const apiUrl = 'http://127.0.0.1:8000/';
// const apiUrl = 'crm.loged.com.br/';

const CreateOrganization = () => {
    const history = useHistory();

    const [appId, setAppId] = useState(null);
    const [status, setStatus] = useState({ type: '', message: '' });

    const [formData, setFormData] = useState({
        name: '',
        description: '',
        cnpj: '',
        email: '',
        phone: '',
        address: ''
    });

    const [fieldsConfig, setFieldsConfig] = useState([]);
    const [fields, setFields] = useState({});

    const loadFields = async (currentAppId) => {
        try {
            const response = await api.get(`v1/apps/${currentAppId}/organization_fields/`);
            setFieldsConfig(response.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    // 🔹 Buscar app padrão
    const pegar_app_padrao = async () => {
        try {
            const response = await api.get('v1/apps/default/');
            const data = response.data;

            if (data?.app?.id) {
                setAppId(data.app.id);
                loadFields(data.app.id);
            } else {
                setStatus({ type: 'error', message: 'App padrão não encontrado' });
            }
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao buscar app padrão' });
        }
    };

    // 🔹 INIT
    useEffect(() => {
        if (!localStorage.getItem('access_token')) return;
        pegar_app_padrao();
    }, []);

    // 🔹 Voltar
    const backPage = () => {
        history.push(`/dashboard/config/organizations/view`);
    };

    // 🔹 Change
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // 🔹 Submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!appId) {
            setStatus({ type: 'error', message: 'App não carregado ainda' });
            return;
        }

        setStatus({ type: '', message: '' });

        try {
            const visibleNames = new Set(fieldsConfig.filter((f) => isFieldVisible(f, fieldsConfig, fields)).map((f) => f.name));
            const fieldsToSend = Object.fromEntries(Object.entries(fields).filter(([name]) => visibleNames.has(name)));

            const response = await api.post(`v1/apps/${appId}/organizations/`, { ...formData, fields: fieldsToSend });

            if (response.data) {
                setStatus({
                    type: 'success',
                    message: 'Organização criada com sucesso!'
                });

                // 🔥 reset correto
                setFormData({
                    name: '',
                    description: '',
                    cnpj: '',
                    email: '',
                    address: ''
                });
                setFields({});
            }
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: error.response?.data?.detail || error.response?.data?.error || 'Erro ao criar organização.'
            });
        }
    };

    return (
        <Box>
            <Typography variant="h3" gutterBottom sx={{ mb: 2 }}>
                Criar Organização
            </Typography>

            <Card>
                <CardContent>
                    {status.message && (
                        <Alert severity={status.type} sx={{ mb: 2 }}>
                            {status.message}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField name="name" label="Nome" fullWidth value={formData.name} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="description"
                                    label="Descrição"
                                    fullWidth
                                    value={formData.description}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField name="cnpj" label="CNPJ/CPF" fullWidth value={formData.cnpj} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="email"
                                    label="Email"
                                    type="email"
                                    fullWidth
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField name="phone" label="Telefone (WhatsApp)" fullWidth value={formData.phone} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="address"
                                    label="Endereço"
                                    type="address"
                                    fullWidth
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                            </Grid>
                            {/* <Grid item xs={12} sm={6}>
                                <TextField
                                    name="role"
                                    select
                                    label="Nível de Permissão"
                                    fullWidth
                                    value={formData.role}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="admin">Administrador</MenuItem>
                                    <MenuItem value="member">Membro da Empresa</MenuItem>
                                    <MenuItem value="end_user">Usuário Final</MenuItem>
                                </TextField>
                            </Grid> */}

                            {fieldsConfig.filter((f) => isFieldVisible(f, fieldsConfig, fields)).map((f) => (
                                <CustomFieldInput
                                    key={f.id}
                                    field={f}
                                    value={fields[f.name]}
                                    onChange={(value) => setFields({ ...fields, [f.name]: value })}
                                />
                            ))}
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="flex-end" gap={2}>
                                    <Button
                                        onClick={backPage}
                                        sx={{
                                            borderRadius: '12px',
                                            px: 3,
                                            py: 1,
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            background: 'linear-gradient(135deg, #ef4444, #b91c1c)',
                                            color: '#fff',
                                            boxShadow: '0 8px 20px rgba(239,68,68,0.4)',
                                            transition: '0.3s',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 12px 30px rgba(239,68,68,0.6)'
                                            }
                                        }}
                                    >
                                        Voltar
                                    </Button>

                                    {/* LIMPAR */}
                                    <Button
                                        type="reset"
                                        variant="outlined"
                                        onClick={() => {
                                            setFormData({
                                                email: '',
                                                first_name: '',
                                                last_name: '',
                                                password: '',
                                                role: 'member',
                                                organization: '',
                                                address: ''
                                            });
                                            setFields({});
                                        }}
                                        sx={{
                                            borderRadius: '12px',
                                            px: 3,
                                            py: 1,
                                            color: '#ccc',
                                            borderColor: '#555',
                                            textTransform: 'none',
                                            '&:hover': {
                                                borderColor: '#999',
                                                background: 'rgba(255,255,255,0.05)'
                                            }
                                        }}
                                    >
                                        Limpar
                                    </Button>

                                    <Button
                                        type="submit"
                                        sx={{
                                            borderRadius: '12px',
                                            px: 4,
                                            py: 1,
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            background: 'linear-gradient(135deg, #22c55e, #4ade80)',
                                            color: '#000',
                                            boxShadow: '0 8px 20px rgba(34,197,94,0.4)',
                                            transition: '0.3s',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 12px 30px rgba(34,197,94,0.6)'
                                            }
                                        }}
                                    >
                                        💾 Criar Organização
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
};

export default CreateOrganization;
